import React from 'react';
import { TableCell, Box, Typography } from '@mui/material';
import ReactCountryFlag from 'react-country-flag';
import { Worker } from '../../../models/worker';
import { COUNTRIES } from '../../../constants/countries';

/** Resolve a nationality string (ISO code or nationality name) to an ISO country code. */
const resolveCountryCode = (nationality: string): string => {
    if (!nationality) return '';
    if (/^[A-Za-z]{2}$/.test(nationality)) return nationality.toUpperCase();
    const entry = COUNTRIES.find((c) => c.nationality.toLowerCase() === nationality.toLowerCase());
    return entry ? entry.code.toUpperCase() : '';
};

const WorkerNationalityCell: React.FC<{ worker: Worker }> = ({ worker }) => {
    const code = resolveCountryCode(worker.nationality || '');
    return (
        <TableCell>
            {code ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ReactCountryFlag
                        countryCode={code}
                        svg
                        cdnUrl="/flags/4x3/"
                        cdnSuffix="svg"
                        style={{ width: '1.2em', height: '1.2em' }}
                        title={code}
                    />
                    <Typography variant="body2">{code}</Typography>
                </Box>
            ) : (
                <Typography variant="body2" color="text.secondary">N/A</Typography>
            )}
        </TableCell>
    );
};

export default WorkerNationalityCell;
